import IconContainer from "./IconContainer"
import { IconProps } from "./IconUtilities"

const IconLayout: React.FC<IconProps> = ({ className, size, contained }) => {
	if (contained) {
		return (
			<IconContainer
				className={className}
				size={size}
			>
				<path d="M12.2727 4.09788H6.81818V8.18879H12.2727V4.09788ZM13.6364 1.37061H1.36364C0.613636 1.37061 0 1.98424 0 2.73424V12.2797C0 13.0297 0.613636 13.6297 1.36364 13.6297H13.6364C14.3864 13.6297 15 13.0297 15 12.2797V2.73424C15 1.98424 14.3864 1.37061 13.6364 1.37061ZM13.6364 12.2865H1.36364V2.72061H13.6364V12.2865V12.2865Z" />
			</IconContainer>
		)
	}
	return (
		<path d="M12.2727 4.09788H6.81818V8.18879H12.2727V4.09788ZM13.6364 1.37061H1.36364C0.613636 1.37061 0 1.98424 0 2.73424V12.2797C0 13.0297 0.613636 13.6297 1.36364 13.6297H13.6364C14.3864 13.6297 15 13.0297 15 12.2797V2.73424C15 1.98424 14.3864 1.37061 13.6364 1.37061ZM13.6364 12.2865H1.36364V2.72061H13.6364V12.2865V12.2865Z" />
	)
}

export default IconLayout
